import styled from "styled-components";
import colors from "../../styles/colors";
import theme from "../../styles/theme";

export const NotFoundContainer = styled.div`
  align-items: center;
  flex: 1;
  flex-direction: column;
  padding: 2.5rem;
  text-align: center;
`;

export const Logo = styled.img`
  margin: 2.5rem;
  max-height: 15rem;
`;

export const GoBackContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

export const GoBack = styled.button`
  background-color: ${colors.lightgrey};
  border: solid 0.15rem ${colors.darkgrey};
  border-radius: 1rem;
  font-family: inherit;
  &:hover {
    background-color: ${colors.darkgrey};
    color: white;
    cursor: pointer;
  }
  svg,
  h2 {
    font-size: ${theme.h2FontSize};
    margin: 1rem;
  }
`;
